import React, { useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Roadmap from "./components/Roadmap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LandingPage from "./components/LandingPage";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiesPolicy from './pages/CookiesPolicy';
import Sitemap from './pages/Sitemap';
import Talents from './pages/Talents';
import Contact from './pages/Contact';
import ProEmail from './pages/ProEmail';
import { ensureFbc, trackPageView } from './lib/metaPixel';
import TrainingRoute from './features/training/TrainingRoute';
import trainingRouteManifest from './features/training/trainingRouteManifest.json';
import MentoringRoute from './features/mentoring/MentoringRoute';
import mentoringRouteManifest from './features/mentoring/mentoringRouteManifest.json';

export const TRAINING_ROUTE_PATHS = Object.freeze([
  ...Object.values(trainingRouteManifest.catalogues),
  ...Object.values(trainingRouteManifest.offers).flatMap((paths) => Object.values(paths)),
]);

export const TRAINING_RECOVERY_PATHS = Object.freeze(
  Object.values(trainingRouteManifest.catalogues).map((path) => `${path}/*`),
);

// The mentoring section owns its header/footer, so it renders a single
// catch-all route rather than the host site chrome.
export const MENTORING_ROUTE_PATHS = Object.freeze(
  Object.values(mentoringRouteManifest.pages).flatMap((paths) => Object.values(paths)),
);

export const MENTORING_RECOVERY_PATHS = Object.freeze(
  Object.values(mentoringRouteManifest.pages).flatMap((paths) => Object.values(paths))
    .map((path) => `${path}/*`),
);

// Tracks SPA route changes for the Meta Pixel / CAPI PageView event. The base
// snippet in public/index.html already fires the first PageView, so this
// skips the very first render to avoid double-counting.
function RouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    ensureFbc();
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App overflow-hidden w-full max-w-[100vw]">
        <RouteTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/roadmap" element={<><Header /><Roadmap /><Footer /></>} />
          <Route path="/talents" element={<><Header /><Talents /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          <Route path="/pro-email" element={<><Header /><ProEmail /><Footer /></>} />
          <Route path="/privacy-policy" element={<><Header /><PrivacyPolicy /><Footer /></>} />
          <Route path="/terms-of-service" element={<><Header /><TermsOfService /><Footer /></>} />
          <Route path="/cookies-policy" element={<><Header /><CookiesPolicy /><Footer /></>} />
          <Route path="/sitemap" element={<><Header /><Sitemap /><Footer /></>} />
          {TRAINING_ROUTE_PATHS.map((path) => (
            <Route key={path} path={path} element={<TrainingRoute />} />
          ))}
          {TRAINING_RECOVERY_PATHS.map((path) => (
            <Route key={path} path={path} element={<TrainingRoute />} />
          ))}
          {MENTORING_ROUTE_PATHS.map((path) => (
            <Route key={path} path={path} element={<MentoringRoute />} />
          ))}
          {MENTORING_RECOVERY_PATHS.map((path) => (
            <Route key={path} path={path} element={<MentoringRoute />} />
          ))}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
